import { render } from "./MiTrActionBtn.vue?vue&type=template&id=c9835e76&scoped=true"
import script from "./MiTrActionBtn.vue?vue&type=script&lang=js"
export * from "./MiTrActionBtn.vue?vue&type=script&lang=js"

import "./MiTrActionBtn.vue?vue&type=style&index=0&id=c9835e76&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9835e76"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
